module.exports = __webpack_public_path__ + "static/media/ThirdContent.a4ce27d1.png";